<template>
  <b-form-group :invalid-feedback="errorTxt"
                :state="state">
    <b-input-group :prepend="label?label:$t('group')">
      <b-form-select
          v-model="inputVal"
          :options="options"
          :state="state"
          :disabled="disabled">
      </b-form-select>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  props: {
    model: Object,
    attribute: {type: String, default: 'group'},
    departmentAttribute: {type: String, default: 'department'},
    departmentFilter: {type: String, default: null},
    label: String,
    errors: Array,
    disabled: Boolean
  },
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      options: [],
      department: this.model[this.departmentAttribute] ? this.model[this.departmentAttribute] : null
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
        if (val[this.departmentAttribute] !== this.department) {
          this.department = this.model[this.departmentAttribute] ? this.model[this.departmentAttribute] : null;
          if (this.department === null) {
            this.inputVal = null;
          }
          this.load();
        }
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    load() {
      this.options = [
        {value: null, text: this.$t('selectGroup')}
      ];
      this.$bgService.get('/group', {
        params: {
          page: 1,
          pageSize: 1000,
          status: '0',
          department: this.department
        }
      }).then(response => {
        let found = false;
        response.data.docs.forEach(item => {
          this.options.push({value: item._id, text: `${item.name} (${item.department.name})`});
          if (item._id === this.model[this.attribute]) {
            found = true;
          }
        });
        if (found) {
          this.inputVal = this.model[this.attribute] ? this.model[this.attribute] : null;
        } else {
          this.inputVal = null;
        }
      });
    }
  },
  mounted() {
    this.department = this.departmentFilter ? this.departmentFilter : null;
    this.load();
  },
  i18n: {
    messages: {
      en: {
        selectGroup: 'Select group',
        group: 'Group'
      },
      vi: {
        selectGroup: 'Chọn nhóm',
        group: 'Nhóm'
      }
    }
  }
}
</script>